import { useSyncExternalStore } from 'react';
import { useSettingsStore } from '../stores/settingsStore';

const mediaQuery =
  typeof window !== 'undefined'
    ? window.matchMedia('(prefers-color-scheme: dark)')
    : null;

function subscribe(callback: () => void) {
  mediaQuery?.addEventListener('change', callback);
  return () => mediaQuery?.removeEventListener('change', callback);
}

function getSystemTheme(): 'light' | 'dark' {
  return mediaQuery?.matches ? 'dark' : 'light';
}

/**
 * Returns the effective theme ('light' | 'dark'), resolving 'system' to the
 * OS preference via matchMedia.
 */
export function useResolvedTheme(): 'light' | 'dark' {
  const theme = useSettingsStore((state) => state.theme);
  const systemTheme = useSyncExternalStore(subscribe, getSystemTheme, (): 'light' | 'dark' => 'light');
  return theme === 'system' ? systemTheme : theme;
}
